import { Notifier } from '@airbrake/browser';

const airbrake = new Notifier({
  projectId: 501332,
  projectKey: 'cbcf51db5482de8e6823569c13eaf258',
  environment: 'production'
});

import updateItinaryAndMeasurements, {reportResult} from "./test_map/itinaryAndMeasurements";
import updateSpeeds from "./test_map/update_speeds";
import {removeAllPoints, currentListOfPoints, showPathCoordinates, initializeMap, addMarker} from "./test_map/map";

import loadAutocomplete from "./test_map/autocomplete";

window.latestResult = null

function showLoading (shouldShowLoading) {
  document.getElementById('loading_icon').classList.toggle('hidden', !shouldShowLoading)
}

async function refreshItinary() {
  showLoading(true)
  const points = currentListOfPoints()
  console.log("itinerary", JSON.stringify(points.map(({lat, lng}) => ({lat, lng}))))

  window.gtag('event', 'view_search_results', {
    'event_label': JSON.stringify(points),
    'event_category': 'engagement',
  });
  window.fbq('track', 'PageView')

  if (points.length >= 2) {
    const result = await updateItinaryAndMeasurements(points)

    showPathCoordinates(result.pathCoordinates)
    reportResult(points, result)

    window.latestResult = result
    window.displayStats(result)
  } else {
    window.latestResult = null
    showPathCoordinates(null)
    window.displayStats({pointCount: points.length})
  }
  showLoading(false)


  if (points.length >= 5) {
    window.gtag('event', 'several_steps', {value: points.length})
    window.fbq('track', 'ViewContent');
  }
}

async function reset() {
  removeAllPoints()

  pushHistoryState()
  await refreshItinary()
}

function pushHistoryState() {
  const points = currentListOfPoints()
  let searchParams = new URLSearchParams()

  searchParams.set('coords', JSON.stringify(points.map(({lat, lng}) => ({lat, lng}))))
  window.history.pushState(null,null, `${window.location.pathname}?${searchParams}`)

  if (window.history.length % 20 == 0 && window.history.length >= 20) {
    const eventName = `moreThan${Math.floor(window.history.length/20) * 20}`
    window.gtag('event', eventName, {value: window.history.length})
    window.fbq('trackCustom', eventName, {length: window.history.length});
  }
}



window.reset = reset
window.refreshItinary = refreshItinary
window.pushHistoryState = pushHistoryState

window.updateSpeeds = updateSpeeds

window.updateItinaryAndMeasurements = updateItinaryAndMeasurements

window.loadAutocomplete = loadAutocomplete

function convertFromSql(coordsLoaded) {
  return coordsLoaded.map( ({latitude, longitude}) => ({lat: latitude, lng: longitude}))
}

function initFromUrl() {
  const searchParam = new URLSearchParams(window.location.search);

  removeAllPoints()

  try {

    let coords = searchParam.get('coords') ? JSON.parse(searchParam.get('coords')) : []

    // fix for debugginf queries in sql
    if (coords.length >= 1 && coords[0].latitude) {
      coords = convertFromSql(coords)
    }

    coords && coords.forEach(addMarker)
    refreshItinary()

    if (coords.length <= 2) { return }

    const southWestLat = Math.min(...(coords.map(({lat}) => lat))) - 0.04
    const southWestLon = Math.min(...(coords.map(({lng}) => lng))) - 0.04
    const northEastLat = Math.max(...(coords.map(({lat}) => lat))) + 0.04
    const northEastLon = Math.max(...(coords.map(({lng}) => lng))) + 0.04

    window.map.fitBounds([
      [southWestLat, southWestLon],
      [northEastLat, northEastLon]
    ])
  } catch (e) {
    if (e.name != 'SyntaxError') { throw e }
  }
}

window.initializePage = () => {
  initializeMap()
  initFromUrl()
}

window.addEventListener('popstate', function (event) {
  initFromUrl()
});
